<template>
  <div class="modal fade" id="paytmreceiptview">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-aqua">
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            <button @click="printPaytmReceiptView()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
        </div>
        <div class="modal-body" id="printPaytmReceiptView">
          <div class="row" v-if="row">
            <div class="col-md-12">
              <!-- Profile Image -->
              <div class="card card-primary card-outline">
                <div class="card-body box-profile">
                    <p class="text-bold text-center">{{getCompanyRecord.companyName}} <br>Online Payment Receipt</p> 
                    <div class="row">
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul class="list-group mb-3">
                          <li class="list-group-item">
                            <b>Branch Name</b>
                              <a
                                class="pull-right"
                                v-if="row.branch"
                                >{{ row.branch.name }}</a
                              >
                          </li>
                          <li class="list-group-item">
                            <b>Cust Name</b>
                            <a class="pull-right">{{ row.name }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Email</b>
                            <a class="pull-right">{{ row.email }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Mobile</b>
                            <a class="pull-right">{{ row.mobile }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Amount</b>
                            <a class="pull-right">{{ row.amt }}</a>
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                  <div class="col-md-6">
                    <!-- Profile Image -->
                    <div class="card card-primary card-outline">
                      <div class="card-body box-profile">
                        <ul class="list-group mb-3">
                          <li class="list-group-item">
                            <b>Received By</b>
                              <a
                                class="pull-right"
                                v-if="row.received_by"
                                >{{ row.received_by.name }}</a
                              >
                          </li>
                          <li class="list-group-item">
                            <b>Payment Mode</b>
                            <a class="pull-right">{{ row.mode }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Order ID</b>
                            <a class="pull-right">{{ row.order_id }}</a>
                          </li>
                          <li class="list-group-item" style="padding-bottom: 28px;">
                            <b>Transaction ID</b>
                            <a class="pull-right">{{ row.transaction_id }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Date</b>
                            <a class="pull-right">{{ row.created_at }}</a>
                          </li>
                          <li class="list-group-item">
                            <b>Status</b>
                            <a>
                              <span v-if="row.status === 1" class="label label-success pull-right">Success</span>
                              <span v-if="row.status === 0" class="label label-danger pull-right">Failed</span>
                              <span v-if="row.status === 2" class="label label-warning pull-right">Processing</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                  </div>
                  <!-- /.col -->
                </div>
                    <p class="text-bold">Note: This is a computer‐generated document. No signature is required</p>
                </div>
                <!-- /.card-body -->
              </div>
                <!-- /.card -->
            </div>
            <!-- /.col -->
          </div>
        </div>
        <div class="modal-footer text-center">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
          >
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'paytmreceipt',
  props: ['row', 'getCompanyRecord'],
  methods: {
    printPaytmReceiptView () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('printPaytmReceiptView').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.4/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
              ${stylesHtml}
              <style type="text/css">
                table th, table td { border:1px solid #000; padding:0.5em; }
              </style>
          </head>
          <body>
              ${prtHtml}
          </body>
        </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaytmReceipt.vue?6cee65c8